export default function PHP_insert_id() {
  return (
    <div>
      <h1>PHP_insert_id</h1>
    </div>
  );
}
